<template>
	<!-- banner -->
	<section v-if="topoBanner != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- noticia detalhe -->
	<section class="ftco-section bg-light">
		<div class="container">
			<div v-if="linhaTextoNoticia != ''" class="row" style="text-align: center;">
				<div class="col-lg-12 ">
					<h2 class="mb-3">{{ linhaTextoNoticia.itiNome }}</h2>
					<p v-html="linhaTextoNoticia.itiResumo1"></p>
					<div><img :src="$imgURL + linhaTextoNoticia.insInstitucionalImagens[0].itgUrlImagem"
							style="width: auto; height: 380px;" class="img-fluid"></div>
					<p v-html="linhaTextoNoticia.itiResumo2" style="padding-top: 50px;"></p><br>
					<button onclick="history.back()" style="padding-top: 15px; font-size: 14px; cursor: pointer;">
						← Voltar
					</button>
				</div>
			</div>
		</div>
	</section>
	<!-- END noticia detalhe -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'
import { useRoute } from 'vue-router';


export default {
	name: 'NoticiasDetalheView',
	components: {

	},
	setup() {
		const route = useRoute();
		const id = route.params.id;
		const nome = route.params.nome;
		return {
			id,
			nome
		};
	},
	data: () => ({
		topoBanner: [],
		linhaTextoNoticia: [],
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Noticias - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
		removerTagsHTML(html) {
			const element = document.createElement('div');
			element.innerHTML = html;
			return element.textContent || element.innerText || '';
		},
	},

	created() {
		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/45/blogtopo/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo Banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});

		//aqui busca noticias
		axios.get('/Process/InsInstitucional/GetById/' + this.id)
			.then(response => {
				this.linhaTextoNoticia = response.data;
				this.carregaMetas(this.removerTagsHTML(this.linhaTextoNoticia.itiResumo1));
				//console.log('this.linhaTextoNoticia')
				//console.log(this.linhaTextoNoticia)

			})
			.catch(error => {
				console.error(error);
			});
	},
}

</script>

<style scoped></style>
